import { render, staticRenderFns } from "./FoundAssets.vue?vue&type=template&id=22bc58ca&scoped=true&"
import script from "./FoundAssets.vue?vue&type=script&lang=js&"
export * from "./FoundAssets.vue?vue&type=script&lang=js&"
import style0 from "./FoundAssets.vue?vue&type=style&index=0&id=22bc58ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc58ca",
  null
  
)

export default component.exports